/**
 * Kifoni — popup de bienvenida.
 * I18N-FR: sin literales traducibles. El único texto que pinta el JS ("Copiado")
 * llega resuelto desde Liquid en data-copied-label (snippets/kifoni-welcome-offer.liquid).
 */
(() => {
  const root = document.querySelector('[data-kf-welcome-root]');
  if (!root || root.dataset.kfWelcomeReady === 'true') return;
  root.dataset.kfWelcomeReady = 'true';

  const dialog = root.querySelector('[data-kf-welcome-dialog]');
  if (!dialog) return;

  const STORAGE_KEY = 'kf-welcome5-v1';
  const SESSION_KEY = 'kf-welcome5-seen';
  const DISMISS_DAYS = 30;
  const SUCCESS_DAYS = 365;
  const isSuccess = Boolean(root.querySelector('[data-kf-welcome-success-panel]'));
  const hasErrors = Boolean(root.querySelector('[data-kf-welcome-error-panel]'));
  let lastFocus = null;
  let timer = null;

  const now = () => Date.now();
  const days = (value) => value * 24 * 60 * 60 * 1000;
  const safeGet = (store, key) => {
    try { return store.getItem(key); } catch (_error) { return null; }
  };
  const safeSet = (store, key, value) => {
    try { store.setItem(key, value); } catch (_error) { /* storage may be blocked */ }
  };

  const suppression = () => {
    const raw = safeGet(window.localStorage, STORAGE_KEY);
    if (!raw) return false;
    try {
      const record = JSON.parse(raw);
      const lifetime = record.status === 'success' ? days(SUCCESS_DAYS) : days(DISMISS_DAYS);
      return Number(record.at) + lifetime > now();
    } catch (_error) {
      return false;
    }
  };

  const track = (action, trigger) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: 'kifoni_welcome_offer', action, trigger: trigger || 'unknown' });
  };

  const open = (trigger = 'automatic', force = false) => {
    if (dialog.open || (!force && suppression())) return;
    lastFocus = document.activeElement;
    if (typeof dialog.showModal === 'function') dialog.showModal();
    else dialog.setAttribute('open', '');
    document.documentElement.classList.add('kf-welcome-is-open');
    safeSet(window.sessionStorage, SESSION_KEY, '1');
    track('open', trigger);
    window.setTimeout(() => {
      const target = dialog.querySelector('[data-kf-welcome-error-panel], [data-kf-welcome-success-panel], input:not([type="hidden"]), button');
      if (target) target.focus({ preventScroll: true });
    }, 40);
  };

  const close = (reason = 'close') => {
    if (!dialog.open && !dialog.hasAttribute('open')) return;
    if (typeof dialog.close === 'function') dialog.close();
    else dialog.removeAttribute('open');
    document.documentElement.classList.remove('kf-welcome-is-open');
    safeSet(window.localStorage, STORAGE_KEY, JSON.stringify({ status: isSuccess ? 'success' : 'dismissed', at: now() }));
    track('close', reason);
    if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus({ preventScroll: true });
  };

  document.querySelectorAll('[data-kf-welcome-open]').forEach((opener) => {
    opener.addEventListener('click', () => open('product_detail', true));
  });
  dialog.querySelectorAll('[data-kf-welcome-close]').forEach((button) => {
    button.addEventListener('click', () => close('button'));
  });
  dialog.addEventListener('cancel', (event) => {
    event.preventDefault();
    close('escape');
  });
  dialog.addEventListener('click', (event) => {
    const box = dialog.getBoundingClientRect();
    const outside = event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom;
    if (outside) close('backdrop');
  });

  const copyButton = dialog.querySelector('[data-kf-copy-code]');
  if (copyButton) {
    copyButton.addEventListener('click', async () => {
      const code = copyButton.dataset.code || '';
      try {
        await navigator.clipboard.writeText(code);
      } catch (_error) {
        const area = document.createElement('textarea');
        area.value = code;
        area.setAttribute('readonly', '');
        area.style.position = 'fixed';
        area.style.opacity = '0';
        document.body.appendChild(area);
        area.select();
        document.execCommand('copy');
        area.remove();
      }
      const label = copyButton.querySelector('[data-kf-copy-label]');
      if (label) label.textContent = copyButton.dataset.copiedLabel || '';
      track('copy_code', 'success');
    });
  }

  if (isSuccess) {
    safeSet(window.localStorage, STORAGE_KEY, JSON.stringify({ status: 'success', at: now() }));
    open('form_success', true);
    return;
  }
  if (hasErrors) {
    open('form_error', true);
    return;
  }

  const path = window.location.pathname;
  const excludedPath = /^\/(cart|account|customer)(\/|$)/.test(path);
  const seenThisSession = safeGet(window.sessionStorage, SESSION_KEY) === '1';
  const isThemeEditor = Boolean(window.Shopify && window.Shopify.designMode);
  if (excludedPath || seenThisSession || suppression() || isThemeEditor) return;
  // Promo ADEC -5 % (30-sep-2026): sin apertura automática; solo se abre desde el aviso de las fichas Sømcasa.
  if (root.dataset.kfWelcomeAuto === 'false') return;

  const autoOpen = () => {
    if (document.visibilityState === 'visible') {
      open('delay_10s');
      return;
    }

    const openWhenVisible = () => {
      if (document.visibilityState !== 'visible') return;
      document.removeEventListener('visibilitychange', openWhenVisible);
      open('delay_10s');
    };
    document.addEventListener('visibilitychange', openWhenVisible);
  };

  timer = window.setTimeout(autoOpen, 10000);
})();
